function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

if (!getCookie('newsletter-bar-closed')) {
  var klaviyoInitInterval = setInterval(function() {
    var klaviyoContainer = document.querySelector('.klaviyo-form-Y4Zhan')

    if (klaviyoContainer.innerHTML != '' && typeof componentHandler == 'object') {
      var emailField = klaviyoContainer.querySelector('input[placeholder="Email"]')
      var birthdayField = klaviyoContainer.querySelector('input[placeholder="DD/MM/YYYY"]')

      if (emailField && birthdayField) {
        clearInterval(klaviyoInitInterval)

        var emailContainer = emailField.parentNode
        var emailLabel = document.createElement('label')
        emailContainer.classList.add('mdl-textfield', 'mdl-js-textfield', 'mdl-textfield--floating-label')
        emailField.classList.add('mdl-textfield__input')
        emailField.removeAttribute('placeholder')
        emailLabel.className = 'mdl-textfield__label'
        emailLabel.htmlFor = emailField.id
        emailLabel.innerHTML = 'Email'
        emailContainer.append(emailLabel)
        componentHandler.upgradeElement(emailContainer)

        var birthdayContainer = birthdayField.parentNode
        var birthdayLabel = document.createElement('label')
        birthdayContainer.classList.add('mdl-textfield', 'mdl-js-textfield', 'mdl-textfield--floating-label')
        birthdayField.classList.add('mdl-textfield__input')
        birthdayField.removeAttribute('placeholder')
        birthdayField.addEventListener('focus', function() { this.placeholder = 'DD/MM/YYYY' })
        birthdayField.addEventListener('blur', function() { this.removeAttribute('placeholder') })
        birthdayLabel.className = 'mdl-textfield__label'
        birthdayLabel.htmlFor = birthdayField.id
        birthdayLabel.innerHTML = 'Birthday'
        birthdayContainer.append(birthdayLabel)
        componentHandler.upgradeElement(birthdayContainer)

        document.querySelector('.newsletter-bar__close img').addEventListener('click', function() {
          setCookie('newsletter-bar-closed', 1, 365)

          document.querySelector('.newsletter-bar').classList.remove('newsletter-bar--opaque')

          setTimeout(function() {
            document.querySelector('.newsletter-bar').classList.remove('newsletter-bar--display')
          }, 400)
        })

        setTimeout(function() {
          document.querySelector('.newsletter-bar').classList.add('newsletter-bar--display', 'newsletter-bar--opaque')
        }, 8000)
      }
    }
  }, 10)
}

setTimeout(function() {
  var klaviyoSignUpSuccessInterval = setInterval(function() {
    if (
      document.querySelector('.klaviyo-sign-up__description') &&
      !document.querySelector('.klaviyo-sign-up__form-container form.klaviyo-form button')
    ) {
      document.querySelector('.klaviyo-sign-up__title').remove()
      document.querySelector('.klaviyo-sign-up__description').remove()
      document.querySelector('.klaviyo-sign-up__small-print').remove()

      clearInterval(klaviyoSignUpSuccessInterval)
    }
  }, 10)
}, 8000)